export enum MyChartSideBarItemType {
  SENDING_DOCUMENTS,
  DISCHARGE_SUMMARY,
  ALLERGIES,
  VACCINES,
  MEDICAL_PRESCRIPTIONS,
  SICK_NOTE,
  PAST_HISTORY,
  MEDICINE,
  TELECONSULTATION_RECORDS
}
